import { useContext } from "react";
import { BusinessTravelContext } from "../BusinessTravel";
import OrderDetail from "./steps/OrderDetail";
import OrderForm from "./steps/OrderForm";
import PaymentForm from "./steps/PaymentForm";
import QuoteForm from "./steps/QuoteForm";

const Step = () => {
  const { currentStep } = useContext(BusinessTravelContext) as any;

  let stepContent: any;

  switch (currentStep) {
    case 0:
      stepContent = <QuoteForm />;
      break;
    case 1:
      stepContent = <OrderForm />;
      break;
    case 2:
      stepContent = <PaymentForm />;
      break;
    case 3:
      stepContent = <OrderDetail />;
      break;

    default:
      stepContent = <QuoteForm />;
      break;
  }

  return stepContent;
};

export default Step;
